import { JobOfferTagBadge } from "./JobOfferTagBadge";

type Props = {
  tags: string[];
};

export function WorkTags({ tags }: Props) {
  return tags.map((tag) => <JobOfferTagBadge key={tag} tag={tag} />);
}
